<template>
  <div v-show="gameCompleted" class="game-over">
    <Avatar
      class="game-over__avatar"
      name="Sherlock"
      game="pumpkinClock"
      :level="5"
      :progress="0.8"
      image="https://images.unsplash.com/photo-1529040181623-e04ebc611e25?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9"
    />
    <Brand type="dark" position="bottom" />
    <div class="game-over__window">
      <div class="game-over__window--message">
        <p v-if="playerScore >= 300">{{ message.win }}</p>
        <p v-else>{{ message.lose }}</p>
      </div>
      <div class="game-over__window--points">
        <div id="stars-left"></div>
        <p>{{ playerScore }} Points</p>
        <div id="stars-right"></div>
      </div>
      <div class="game-over__window--buttons">
        <button class="game-over__window--buttons_retry" @click="clickRetryButton">
          <img id="retry" src="@/assets/practices/pumpkin_clock/retry.svg" alt="retry" />
        </button>
        <button class="game-over__window--buttons_next-game">Next Game</button>
      </div>
    </div>
    <!-- <img class="game-over__witch-avatar" src="@/assets/witch_avatar.svg" alt="witch-avatar" /> -->
    <div id="witch-gameover"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'GameOver',
  components: {
    Avatar: () => import('@/components/practices/Avatar.vue'),
    Brand: () => import('@/components/practices/Brand.vue'),
  },
  data: () => ({
    message: {
      win: 'Congratulations! You got:',
      lose: 'You can do better, try again!',
    },
  }),
  computed: {
    ...mapGetters({
      currentExercise: 'pumpkinClock/currentExercise',
      currentLives: 'pumpkinClock/currentLives',
      exerciseCompleted: 'pumpkinClock/exerciseCompleted',
      gameCompleted: 'pumpkinClock/gameCompleted',
      playerScore: 'pumpkinClock/playerScore',
    }),
  },
  watch: {
    gameCompleted(value) {
      if (value) {
        if (this.playerScore > 200) {
          sounds.globalScoreWin.play();
        }
        if (this.playerScore <= 200 && this.playerScore > 0) {
          sounds.globalScorePass.play();
        }
        if (this.playerScore === 0) {
          sounds.globalScoreLose.play();
        }
      }
    },
  },
  mounted() {
    const starsLeft = lottie.loadAnimation({
      container: document.getElementById('stars-left'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/global/animations/stars_left.json',
    });
    const starsRight = lottie.loadAnimation({
      container: document.getElementById('stars-right'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/global/animations/stars_right.json',
    });
    starsLeft.setSpeed(0.75);
    starsRight.setSpeed(0.75);
    const witchGameOverAnimation = lottie.loadAnimation({
      container: document.getElementById('witch-gameover'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: '/assets/practices/pumpkin_clock/animations/witch_gameover.json',
    });
    witchGameOverAnimation.play();
  },
  methods: {
    ...mapActions({ resetGame: 'pumpkinClock/resetGame' }),
    clickRetryButton() {
      sounds.globalButton.play();
      this.resetGame();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.game-over {
  @include flex-center;
  color: $pumpkin-clock-color-main;
  background-color: #84c8f5;
  background-image: url('~@/assets/practices/pumpkin_clock/background_home.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  height: 100vh;
  font-family: 'VanillaExtractRegular';

  .game-over__window {
    @include flex-center;
    flex-direction: column;
    color: $pumpkin-clock-color-main;
    background-color: #00000090;
    border: 1vh solid $pumpkin-clock-color-main;
    border-radius: 7.5vh;
    height: 70vh;
    width: 75vw;
    position: absolute;

    .game-over__window--message {
      color: $pumpkin-clock-color-alt-second;
      margin-bottom: 2vh;
    }

    .game-over__window--points {
      @include flex-center;
      flex-direction: row;
      font-size: 1.35em;

      #stars-left,
      #stars-right {
        height: 4em;
        width: 4em;
        margin-top: -10vh;
      }
    }
  }

  button {
    color: $pumpkin-clock-color-main;
    background-color: $pumpkin-clock-color-alt-second;
  }

  p {
    padding: 2vw;
  }

  #retry {
    height: 1em;
    padding: 0 1em;
  }

  .game-over__avatar {
    z-index: 2;
  }

  #witch-gameover {
    bottom: 0;
    height: 55vh;
    position: absolute;
    right: 0;
    width: 55vh;
  }
}

@media (max-aspect-ratio: 8/5) {
  .game-over {
    #witch-gameover {
      height: 40vh;
      width: 40vh;
    }
  }
}
</style>
